// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-dropdown-menu {
  width: 100%;
  min-width: 100%;
  position: absolute;
  opacity: 0;
  box-shadow: 0;
  padding: 0;
  margin-top: 10px;
  border-radius: 6px;
  background-color: var(--primary-color-light-500);
  transform-origin: top center;
  pointer-events: none;
  z-index: var(--z-index-popup);
  left: 0;
  top: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
@media screen and (max-width: 992px) {
  .ui-dropdown-menu {
    min-width: 180px;
    width: auto;
    max-height: 300px;
  }
}
.ui-dropdown-menu.align-right {
  left: auto;
  right: 0;
  transform-origin: top right;
}
.ui-dropdown-menu.active {
  opacity: 1;
  box-shadow: 0 -3px 20px 4px rgba(16, 24, 40, 0.12), 0 8px 12px -8px rgba(16, 24, 40, 0.08);
  pointer-events: auto;
}
.ui-dropdown-menu.opening {
  animation: dropdown-zoom-in 220ms cubic-bezier(0.2, 0, 0, 1) both;
  pointer-events: auto;
}
.ui-dropdown-menu.closing {
  animation: dropdown-zoom-out 150ms ease-in both;
  pointer-events: none;
}
.ui-dropdown-menu a:first-child {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.ui-dropdown-menu a:first-child .ui-dropdown-menu__item {
  padding-top: 8px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.ui-dropdown-menu a:last-child {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ui-dropdown-menu a:last-child .ui-dropdown-menu__item {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  padding-bottom: 8px;
}
.ui-dropdown-menu__item {
  cursor: pointer;
  padding: 8px 14px;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: 0.3s;
}
.ui-dropdown-menu__item:hover {
  background-color: color-mix(in srgb, var(--primary-color-dark-600) 20%, transparent);
  transition: 0.3s;
}
.ui-dropdown-menu__item.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.ui-dropdown-menu__item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.ui-dropdown-menu__item__icon svg {
  width: 24px;
  height: 24px;
}
.ui-dropdown-menu__item__circle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  font-size: 14px;
  margin-right: 5px;
}
.ui-dropdown-menu__item__circle i {
  font-size: inherit;
  color: inherit;
  max-width: 14px;
}
.ui-dropdown-menu__item__text {
  color: var(--primary-color-dark-850);
  font-family: var(--tertiary-font);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  white-space: normal;
  overflow-wrap: break-word;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/DropDownMenu.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EAEA,4BAAA;EACA,oBAAA;EACA,6BAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAIE;EApBF;IAqBI,gBAAA;IACA,WAAA;IACA,iBAAA;EADF;AACF;AAGE;EACE,UAAA;EACA,QAAA;EACA,2BAAA;AADJ;AAIE;EACE,UAAA;EACA,0FAAA;EACA,oBAAA;AAFJ;AAKE;EACE,iEAAA;EACA,oBAAA;AAHJ;AAME;EACE,+CAAA;EACA,oBAAA;AAJJ;AAQI;EACE,4BAAA;EACA,2BAAA;AANN;AAOM;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;AALR;AAUI;EACE,+BAAA;EACA,8BAAA;AARN;AASM;EACE,+BAAA;EACA,8BAAA;EACA,mBAAA;AAPR;AAaE;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAXJ;AAaI;EACE,oFAAA;EACA,gBAAA;AAXN;AAcI;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;AAZN;AAeI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAbN;AAeM;EACE,WAAA;EACA,YAAA;AAbR;AAiBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAfN;AAiBM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAfR;AAmBI;EACE,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAjBN","sourcesContent":["\n.ui-dropdown-menu {\n  width: 100%;\n  min-width: 100%;\n  position: absolute;\n  opacity: 0;\n  box-shadow: 0;\n  padding: 0;\n  margin-top: 10px;\n  border-radius: 6px;\n  background-color: var(--primary-color-light-500);\n  $dropdown-menu: &;\n  transform-origin: top center;\n  pointer-events: none;\n  z-index: var(--z-index-popup);\n  left: 0;\n  top: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  // Mobile responsive - ensure proper sizing and scrolling\n  @media screen and (max-width: 992px) {\n    min-width: 180px;\n    width: auto;\n    max-height: 300px;\n  }\n\n  &.align-right {\n    left: auto;\n    right: 0;\n    transform-origin: top right;\n  }\n\n  &.active {\n    opacity: 1;\n    box-shadow: 0 -3px 20px 4px rgba(16, 24, 40, 0.12), 0 8px 12px -8px rgba(16, 24, 40, 0.08);\n    pointer-events: auto;\n  }\n\n  &.opening {\n    animation: dropdown-zoom-in 220ms cubic-bezier(0.2, 0, 0, 1) both;\n    pointer-events: auto;\n  }\n\n  &.closing {\n    animation: dropdown-zoom-out 150ms ease-in both;\n    pointer-events: none;\n  }\n\n  a {\n    &:first-child {\n      border-top-right-radius: 6px;\n      border-top-left-radius: 6px;\n      #{$dropdown-menu}__item {\n        padding-top: 8px;\n        border-top-right-radius: 6px;\n        border-top-left-radius: 6px;\n      }\n\n    }\n\n    &:last-child {\n      border-bottom-right-radius: 6px;\n      border-bottom-left-radius: 6px;\n      #{$dropdown-menu}__item {\n        border-bottom-right-radius: 6px;\n        border-bottom-left-radius: 6px;\n        padding-bottom: 8px;\n      }\n    }\n  }\n\n\n  &__item {\n    cursor: pointer;\n    padding: 8px 14px;\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    transition: .3s;\n\n    &:hover {\n      background-color: color-mix(in srgb, var(--primary-color-dark-600) 20%, transparent);\n      transition: .3s;\n    }\n\n    &.disabled {\n      opacity: 0.5;\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n\n    &__icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      flex-shrink: 0;\n\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    &__circle {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 22px;\n      width: 22px;\n      border-radius: 50%;\n      font-size: 14px;\n      margin-right: 5px;\n\n      i {\n        font-size: inherit;\n        color: inherit;\n        max-width: 14px;\n      }\n    }\n\n    &__text {\n      color: var(--primary-color-dark-850);\n      font-family: var(--tertiary-font);\n      font-size: 14px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 17px;\n      white-space: normal;\n      overflow-wrap: break-word;\n      flex: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
